import React, { useState, useCallback } from "react";
import { ToastContext } from "./toastContext";

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  const addToast = useCallback((message, type = "success-info", ttl = 3500, force = false) => {
    // Check if toasts are enabled (except for error toasts or forced toasts)
    const toastsEnabled = localStorage.getItem('toastsEnabled');
    if (!force && toastsEnabled !== null && !JSON.parse(toastsEnabled) && type !== 'error-warning') {
      return;
    }
    
    const id = Date.now() + Math.random();
    setToasts((t) => [...t, { id, message, type }]);
    if (ttl > 0) {
      setTimeout(() => {
        setToasts((t) => t.filter((x) => x.id !== id));
      }, ttl);
    }
    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((t) => t.filter((x) => x.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ toasts, addToast, removeToast }}>
      {children}
    </ToastContext.Provider>
  );
};
